import React, { createContext, useEffect, useState } from "react";

export const SoftValidationContext = createContext({});

export const SoftValidationProvider = ({ tooltip, enableWarning = false, hasWarning, children }) => {
    const [displayWarning, setDisplayWarning] = useState(enableWarning && hasWarning);

    useEffect(() => {
        if (hasWarning) {
            setDisplayWarning(true);
        } else {
            setDisplayWarning(false);
        }
    }, [hasWarning]);

    return (
        <SoftValidationContext.Provider value={{ toggleWarning: setDisplayWarning, displayWarning, enableWarning, tooltip }}>
            {children}
        </SoftValidationContext.Provider>
    );
};
